import { RGBTuple } from './types';

const RED = 0.2126;
const GREEN = 0.7152;
const BLUE = 0.0722;

const GAMMA = 2.4;

// NB: I got these from the internet. They might as well be considered a magical black box. The coefficients are
// meaningless numbers to me, but here they are.
const getLuminance = (rgb: RGBTuple): number => {
    const a = rgb.map((v) => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, GAMMA);
    });

    return a[0] * RED + a[1] * GREEN + a[2] * BLUE;
};

export const getContrast = (rgb1: RGBTuple, rgb2: RGBTuple): number => {
    const lum1 = getLuminance(rgb1);
    const lum2 = getLuminance(rgb2);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
};

export const hexToRgb = (hex: string): RGBTuple | undefined => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result && result.length === 4
        ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
        : undefined;
};
